module.exports = __webpack_public_path__ + "7828b833ab4c602d0e1ae3a00fb44fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/R@2x.png
// module id = 843
// module chunks = 0